
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWidgets as ObiWidgetsElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-widgets.js';
 
 
 

 
 export const ObiWidgets = createComponent({
   react: React,
   tagName: 'obi-widgets',
   elementClass: ObiWidgetsElement,
   events: {
     
   }
  });
 
 